import { Controller } from "@hotwired/stimulus"

// Pure-client toggle for the "Aucune de ces BD ne vous tente?" reveal
// section on the BD selection page. No server roundtrip is needed —
// the alternatives markup is rendered server-side and just shown/hidden
// in place when the user clicks the toggle.
export default class extends Controller {
  static targets = ["button", "section"]

  toggle() {
    const expanded = this.buttonTarget.getAttribute("aria-expanded") === "true"
    if (expanded) {
      this.sectionTarget.hidden = true
      this.buttonTarget.setAttribute("aria-expanded", "false")
      this.buttonTarget.classList.remove("is-expanded")
    } else {
      this.sectionTarget.hidden = false
      this.buttonTarget.setAttribute("aria-expanded", "true")
      this.buttonTarget.classList.add("is-expanded")
      requestAnimationFrame(() => {
        const top = this.sectionTarget.getBoundingClientRect().top + window.pageYOffset - 20
        window.scrollTo({ top, behavior: "smooth" })
      })
    }
  }
}
